import React, { useEffect, useState } from "react";
import AddUserGrid from "./AddUserGrid";
import UserModal from "./UserModal";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import PageHeader from "../../shared/page-header/PageHeader";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import { getModulePermissions, getUserPermissions, hasPermission } from '../../utils/permissionHelper';
import { logAuditEvent } from '../../utils/auditLogger';

function AddUserMain(props) {
  const [getUserList, setUserList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Users';

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
     setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchUser();
  }, []);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Users');
  }, [moduleName]);

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add user modal');
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "AddUser") {
      //const element = document.getElementById("AddUserDetails");
      const userModel = data;
      if(userModel){
        logAuditEvent(moduleName, 'Save User Attempt', userModel.UserId ? `UserId=${userModel.UserId}` : userModel.UserName);
        let registerDetails = {
          FullName: userModel.FullName,
          UserName: userModel.UserName,
          Email: userModel.Email,
          PhoneNumber: userModel.PhoneNumber,
          PasswordHash: userModel.Password,
          ConfirmPassword: userModel.ConfirmPassword,
          UserId: null,
          RoleId: userModel.RoleId,
          CompanyId: userModel.CompanyId,
          ModuleId: userModel.DefaultModuleId
        };
        if (validation(registerDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/register",
              registerDetails
            );
            if (response.status === 200) {
              if(response.data.data[0].success === 1){
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                logAuditEvent(moduleName, 'User Saved', response.data.data[0].message || 'Success');
                fetchUser();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
            logAuditEvent(moduleName, 'User Save Failed', error.message || 'Unknown error');
          }
        }
      } else {
        CreateAlert("Please enter proper data!!", "Error", setAlert);
      }
    } 
  }
  function validation(userDetails) {
    var validation = true;
    if (userDetails) {
      if (userDetails.FullName !== null) {
        if (userDetails.FullName.length === 0) {
          CreateAlert("Please enter user full name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter user full name!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.Email) {
        if (userDetails.Email.length === 0) {
          CreateAlert("Please enter email!!", "Warning", setAlert);
          validation = false;
          return;
        } else {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(userDetails.Email)) {
            CreateAlert("Please enter valid email id!!", "Warning", setAlert);
            validation = false;
            return;
          } 
        }
      } else {
        CreateAlert("Please enter email!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.UserName) {
        if (userDetails.UserName.length === 0) {
          CreateAlert("Please enter user name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter user name!!", "Warning", setAlert);
        validation = false;
        return;
      }
      
      if (userDetails.PasswordHash) {
        if (userDetails.PasswordHash.length === 0) {
          CreateAlert("Please enter password!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter password!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.ConfirmPassword !== userDetails.PasswordHash) {
        CreateAlert("Password and Confirm Password does not match!!", "Error", setAlert);
        validation = false;
        return;
      }

      if (userDetails.RoleId) {
        if (userDetails.RoleId.length === 0) {
          CreateAlert("Please select role!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please select role!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }

    return validation;
  }
  const fetchUser = async () => {
    try {
      let registerDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/userlist" , { params: registerDetails });
      if (response.status === 200) {
        setUserList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader 
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <AddUserGrid UserData={getUserList} fetchUser={fetchUser} UserPermissions={getUserModulePermission} />
      <UserModal
        show={modalIsOpen}
        UserAction={"AddUser"}
        onClose={closeModal}
        onSubmit={onSubmit}
        selectedRow={undefined}
      />
    </>
  );
}

export default AddUserMain;
